"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _encryption = require("blockstack/lib/encryption");

var _config = require("./config");

var _api = require("./api");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Central =
/*#__PURE__*/
function () {
  function Central() {
    _classCallCheck(this, Central);
  }

  _createClass(Central, null, [{
    key: "save",
    value: function save(key, value) {
      var _this$makeSignature = this.makeSignature(key),
          username = _this$makeSignature.username,
          signature = _this$makeSignature.signature;

      return (0, _api.saveCentral)({
        username: username,
        key: key,
        value: value,
        signature: signature
      });
    }
  }, {
    key: "get",
    value: function get(key) {
      var _this$makeSignature2 = this.makeSignature(key),
          username = _this$makeSignature2.username,
          signature = _this$makeSignature2.signature;

      return (0, _api.fetchCentral)(key, username, signature);
    }
  }, {
    key: "makeSignature",
    value: function makeSignature(key) {
      var _ref = (0, _config.getConfig)(),
          userSession = _ref.userSession;

      var _userSession$loadUser = userSession.loadUserData(),
          appPrivateKey = _userSession$loadUser.appPrivateKey,
          username = _userSession$loadUser.username;

      var message = "".concat(username, "-").concat(key);

      var _ref2 = (0, _encryption.signECDSA)(appPrivateKey, message),
          signature = _ref2.signature;

      return {
        username: username,
        signature: signature
      };
    }
  }]);

  return Central;
}();

var _default = Central;
exports.default = _default;